export enum TeamListShowType {
  /** 显示团队列表 */
  own = 'own',
  /** 显示邀请列表 */
  invite = 'invite',
}

